import { useCallback } from 'react';
import StoreComplementDB from '../../../../../database/wrappers/storeComplement';
import useBasePriceImport from '../../../pdv/product/hooks/useBasePriceImport';

const chunkArray = (list, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < list.length; i += chunkSize) {
    chunks.push(list.slice(i, i + chunkSize));
  }
  return chunks;
};

const useStoreComplementPriceImport = ({
  establishmentId,
  storeId,
  complements,
  onShowAlert,
}) => {
  const handleSaveRows = useCallback(async (rowsToUpdate) => {
    const storeComplementDB = new StoreComplementDB(establishmentId, storeId);
    const chunks = chunkArray(rowsToUpdate, 200);

    for (const chunk of chunks) {
      await Promise.all(chunk.map((item) => {
        if (item.storeProdExist) {
          return storeComplementDB.update(item.id, { price: item.newPrice });
        }
        return storeComplementDB.define(item.id, { price: item.newPrice });
      }));
    }
  }, [establishmentId, storeId]);

  return useBasePriceImport({
    canImport: !!establishmentId && !!storeId,
    products: complements,
    onShowAlert,
    onSaveRows: handleSaveRows,
    messages: {
      saveError: 'Falha ao atualizar preços dos complementos da loja.',
    },
  });
};

export default useStoreComplementPriceImport;
